import React from 'react';
import ReactDOM from 'react-dom';
import { Router } from 'react-router-dom';
import { createBrowserHistory } from 'history';
import request from 'services/request';
import App from './App';

request.handlingRequest();

ReactDOM.render(
    <Router history={createBrowserHistory({})}>
        <App />
    </Router>,
    document.getElementById('root')
);
